import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import css from './CookieBlock.module.scss';

class CookieBlock extends React.PureComponent {
    static propTypes = {
        text: PropTypes.string.isRequired,
        linkText: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    };

    state = {
        firstVisit: false,
    };

    componentDidMount() {
        if (!localStorage.getItem('af-cookies')) {
            this.setState({
                firstVisit: true,
            });
        }
    }

    close = () => {
        localStorage.setItem('af-cookies', 'true');

        this.setState({
            firstVisit: false,
        });
    };

    render() {
        const { text, linkText, url } = this.props;

        if (!this.state.firstVisit) return null;

        return (
            <div className={css.block}>
                <div className={css.content}>
                    <p>
                        {text}{' '}
                        <a target="_blank" href={url}>
                            {linkText}
                        </a>
                    </p>
                </div>
                <div className={css['icon-container']} onClick={this.close}>
                    <Icon className={css.icon} icon="close" />
                </div>
            </div>
        );
    }
}

export default CookieBlock;



// WEBPACK FOOTER //
// ./src/components/CookieBlock/CookieBlock.jsx